<script>
export default {
  name: 'componentData',
  props: {
    data: Object
  },
}
</script>